export default __webpack_public_path__ + "c8569944c84c4155a385404545a21d2f.png";